// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesModel,
  IMappers,
  TDeleteOfferFromFavoritesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IDefaultSuccessResponseSchema } from '../../entities/delete_user_favorites/DefaultSuccessResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeleteOfferFromFavoritesModel(
  parameters: TDeleteOfferFromFavoritesRequest,
): TDeleteOfferFromFavoritesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/delete-offer-from-favorites/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteOfferFromFavoritesRequest;
}

export async function fetchDeleteOfferFromFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromFavoritesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeleteOfferFromFavoritesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteOfferFromFavoritesModel(parameters),
    config,
  )) as FetchResponse<TDeleteOfferFromFavoritesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDefaultSuccessResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }

  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeleteOfferFromFavoritesResponse>;
}
